import { temAcesso } from '@/shared/auth/temAcesso'

const Convenios = () => import('./ConvenioLista.vue')
const Detalhes = () => import('./detalhes/ConvenioDetalhes.vue')

export default {
    path: 'convenio',
    name: 'GesconConvenio',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-FORN-CONV-00')) {
            next()
        }
    },
    children: [
        {
            path: '/gescon/convenios',
            name: 'GesconConvenios',
            component: Convenios,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-FORN-CONV-00')) {
                    next()
                }
            }
        },
        {
            path: '/gescon/convenios/detalhes/:idConvenio',
            name: 'GesconConveniosDetalhes',
            component: Detalhes,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-FORN-CONV-00')) {
                    next()
                }
            }
        }
    ]
}
